import { useState } from "react";
import { UseFormSetValue } from "react-hook-form";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IMaterialsResponse } from "@miplatform/types";
import { useAreaTypes } from "@mibuildweb/hooks";
import { IAddRequirementsData } from "../../schema/addRequirements.schema";

export const useRequirementAttachItemsViewModel = ({
  materialAreas,
  setValue,
}: {
  materialAreas: Record<string, string[]>;
  setValue: UseFormSetValue<IAddRequirementsData>;
}) => {
  const stateManager = useComponentState();
  const {
    areaTypes,
    getAreaTypes,
    isLoading: isAreaTypesLoading,
  } = useAreaTypes();

  const [allMaterials, setAllMaterials] = useState<IMaterialsResponse[]>([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState<string | null>(
    null
  );

  const loadMaterials = () => {
    stateManager.run(async () => {
      const response = await homeService.materials.getAll({
        sort: { category: ["categoryName", "itemCode"] },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setAllMaterials(response.data);
      }
    });
  };

  const handleTabChange = (materialId: string) => {
    setSelectedMaterialId(materialId);
  };

  const getSelectedAreaIds = (materialId: string): string[] =>
    materialAreas[materialId] ?? [];

  const handleAddArea = (materialId: string, areaTypeId: string) => {
    const current = materialAreas[materialId] ?? [];
    setValue(
      "materialAreas",
      { ...materialAreas, [materialId]: [...current, areaTypeId] },
      { shouldDirty: true, shouldValidate: true }
    );
  };

  const handleRemoveArea = (materialId: string, areaTypeId: string) => {
    const current = materialAreas[materialId] ?? [];
    setValue(
      "materialAreas",
      {
        ...materialAreas,
        [materialId]: current.filter((id) => id !== areaTypeId),
      },
      { shouldDirty: true, shouldValidate: true }
    );
  };

  return {
    isLoading: stateManager.isBusy() || isAreaTypesLoading,
    allMaterials,
    areaTypes,
    selectedMaterialId,
    loadMaterials,
    getAreaTypes,
    handleTabChange,
    getSelectedAreaIds,
    handleAddArea,
    handleRemoveArea,
    setSelectedMaterialId,
  };
};
